export async function fetchSearchData(search: SearchInput) {
  const query = `
      {
        search(
          query: "${search.searchText}",
          first: 1,
          content_types: "${search.searchContentTypes}",
          tags: "${search.searchTags}",
          topics: "${search.searchTopics}"
        ) {
          files {
            id
            title
            hash
            allowed
            fileName
            cover { path }
            url
            description
            size
            downloads_count
            media_type
            video_link
            blog_link
            is_downloadable
            is_featured
            embed_code
            created_at
            updated_at
            content_type_id
            productFocusPlans {
              label
              is_free
            }
            contentType {
              id
              name
              slug
            }
            tags {
              id
              name
              slug
            }
          }
          tags {
            id
            name
            slug
            filesCount
          }
          contentTypes {
            id
            name
            slug
            filesCount
          }
          topics {
            id
            name
            slug
            filesCount
          }
          pageContents {
            title
            slug
          }
        }
      }
    `;

  try {
    const result = await getQuery(query);

    if (!result || !result.search) throw new Error("Invalid search response");

    return result;
  } catch (err) {
    return null;
  }
}
